import { render, staticRenderFns } from "./ArticleRow.vue?vue&type=template&id=123819b6&scoped=true&"
import script from "./ArticleRow.vue?vue&type=script&lang=js&"
export * from "./ArticleRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123819b6",
  null
  
)

export default component.exports